export default {
  namespaced: true,
  hikvision_dvr: {
    section: 'hikvision',
    title: "hikvision DVR | hikvision DVR's",
    name: "nome",
    ip: "IP",
    masterAccount: "conta mestra",
    tenant: "tenant",
    http_schema: "esquema http(s)",
    rtsp_schema: "esquema rtsp(s)",
    http_port: "porta http",
    rtsp_port: "porta rtsp",
    cameras: "câmeras",
    syncSuccess: "sincronizado corretamente",
    admin_url: "Link Admin",
    hls_url: "Link HLS",
    websocket_url: "Link Websocket"
  },
};
